export const EMPLOYMENT_V2_VALUES = {
  EMPLOYED: 'WORKER',
  RETIRED: 'RETIRED',
  STUDENT: 'STUDENT',
  UNEMPLOYED: 'UNEMPLOYED',
};
